
import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import FilterList from '@mui/icons-material/FilterList';
import moment from 'moment'
import { RefineryFilter, RefineryComponent, RefineryCrudeEvaluation } from '.'
import { Lastupdate } from '../../../components';

export const RefineryModel = ({ type: initType }) => {
    const { type: path } = useParams()
    const type = initType || path
    const [conditions, setConditions] = useState({ unit: 'CDU', region: 'All', subRegion: 'All', country: 'All', start: moment().format('YYYY-01-01'), end: moment(moment().format('YYYY-01-01')).add(12, 'month').format('YYYY-MM-01') })
    const [expanded, setExpanded] = useState(false)

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false)
    }

    const callback = event => {
        setConditions(event)
        console.log('called', event)
        setExpanded(false)
    }

    return <>
        {type === 'model' ? <RefineryCrudeEvaluation /> : 
        <div className="column-center">
            <Accordion expanded={expanded === 'panel'} className={`w-95p ${expanded === 'panel' ? '' : 'box-shadow-0'}`} onChange={handleChange('panel')}>
                <AccordionSummary expandIcon={<FilterList />}>
                    <Lastupdate type={`refinery:${type.toLowerCase()}`} align='left'/>
                </AccordionSummary>
                <AccordionDetails className='column'>
                    <RefineryFilter type={`refinery:${type.toLowerCase()}`} init={conditions} callback={callback} />
                </AccordionDetails>
            </Accordion>
            <div className='row-center'>
                <RefineryComponent type={type} conditions={conditions} />
            </div>
        </div>}
    </>
}